import type { FC } from "react";
import { useTranslation } from "@privacy/translations";
import { usePermission } from "../../shared/permissions";
import { DynamicGrid } from "../../dynamicGrid";
import { usePrivacyNavigate } from "../../shared/usePrivacyNavigate";
import { PageTitle } from "../../shared/Page";
import { CreateSystemDialog } from "./CreateSystemDialog";

export const SystemsGridToolbar: FC = () => {
  const { t } = useTranslation();
  const { hasPermission } = usePermission();
  const { navigate, paths } = usePrivacyNavigate();

  return (
    <DynamicGrid.Toolbar
      pageTitle={<PageTitle title={t("SystemsGrid.Title")} subTitle={t("SystemsGrid.SubTitle")} />}
      actionButtons={
        <>
          <DynamicGrid.ExportButton />

          {hasPermission("nova-forms-api:system:create") && (
            <DynamicGrid.CreateNewButton
              labelKey="CreateSystem.Button"
              renderDialog={({ onClose }) => (
                <CreateSystemDialog onClose={onClose} onCreated={system => navigate(paths.systemsInline(system.id))} />
              )}
            />
          )}
        </>
      }
      filterButtons={
        <>
          <DynamicGrid.ColumnFilterButton />
          <DynamicGrid.FilterButton />
        </>
      }
    />
  );
};
